module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"details":"Coordonnées","aisc-registration-number":"Numéro AISC","submit":"Valider"},"en":{"details":"Contact details","aisc-registration-number":"AISC registration number","submit":"Submit"}}')
  delete Component.options._Ctor
}
